import { timeZone } from 'tio-common/utils/date/time-zone';
import { generateRequestId } from 'tio-common/utils/request-id';
import ApplicationAdapter from './application';
import ENV from 'tio-employee/config/environment';

/**
 * An extended adapter for the `UserLogin` model.
 *
 * @memberof adapters
 */
class LoginAdapter extends ApplicationAdapter {
  async sendForgotPassword(email: string) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('login') + '/forgot-password';
    return await this.ajax(url, 'POST', {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': ENV.apiKey,
        'Time-Zone': timeZone(),
        'X-Request-Id': generateRequestId(),
      },
      body: JSON.stringify({
        email,
      }),
    });
  }

  async validateResetPasswordToken(token: string) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('login') + '/validate-reset-token';
    try {
      return await this.ajax(url, 'POST', {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ENV.apiKey,
          'Time-Zone': timeZone(),
          'X-Request-Id': generateRequestId(),
        },
        body: JSON.stringify({ token }),
      });
    } catch (_error) {
      return { success: false };
    }
  }

  async resetPassword({
    password,
    passwordConfirmation,
    token,
  }: {
    password: string;
    passwordConfirmation: string;
    token: string;
  }) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('login') + '/reset-password';
    return await this.ajax(url, 'POST', {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': ENV.apiKey,
        'Time-Zone': timeZone(),
        'X-Request-Id': generateRequestId(),
      },
      body: JSON.stringify({
        password,
        passwordConfirmation,
        token,
      }),
    });
  }
}

export default LoginAdapter;
